export enum reportActivityDetailsProperties {
  TimeStamp = 'TimeStamp',
  PartitionKey = 'PartitionKey',
  RowKey = 'RowKey',
  CompanyId = 'CompanyId',
  ReportId = 'ReportId',
  ReportGroup = 'Report Group',
  ReportName = 'Report Name',
  BlobName = 'Blob Name',
  ReportType = 'Report Type',
  StartTime = 'StartTime',
  EndTime = 'EndTime',
  BlobContainerName = 'Blob Container Name',
  ErrorMessage = 'Error Message',
  IsEmail = 'Is Email',
  Status = 'Status',
}
